var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.length)?_c(_vm.element,{tag:"component",class:_vm.listingsClasses},[_vm._l((_vm.data),function(item,index){return [_vm._t("default",null,null,item)]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }